const FilterOuter: React.FC = ({ children, ...props }) => (
	<div {...props}>{children}</div>
);

export default FilterOuter;
